import Vue from 'vue'
import Vuex from 'vuex'
import contactModule from './storejs/contactMod';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    vsnackbar: {
      Show: false,
      Msg: '',
    },
  },
  mutations: {
    set_vsnackbar_Show: (state, data) => {
      state.vsnackbar.Show = data
    },
    set_vsnackbar_Msg: (state, data) => {
      state.vsnackbar.Msg = data
    },
  },
  actions: {
  },
  modules: {
    contactMod: contactModule,
  },
})
